import GuideSearchResultList from './GuideSearchResultList';

export default GuideSearchResultList;
